module.exports = __webpack_public_path__ + "static/img/creative-banner.88adeb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/creative-banner.png
// module id = vftr
// module chunks = 1